export const userContents = `{
    id
    displayName
    emailNotifications
    avatarURL
    languages {
        language
        isLearning
        level
    }
}`;

const reactionContents = `{
    id
    userId
    creationDate
}`;

const correctionContents = `{
    id
    postId
    reactions ${reactionContents}
    body
    authorId
    comment
    creationDate
    lastUpdateDate
    author ${userContents}
    edits {
        id
        correctionId
        startIndex
        length
        newText
        comment
    }
}`;

export const postContents = `{
    id
    creationDate
    lastUpdateDate
    reportedUsers
    reactions ${reactionContents} 
    body
    language
    author ${userContents}
    authorId
    corrections ${correctionContents}
}`;

export const graphQLCorrectionContents = includeTotalCount => `{
    ${includeTotalCount ? "totalCount" : ""}
    edges {
        node ${correctionContents}
        cursor
    }
    pageInfo {
        endCursor
        hasNextPage
    }
}`;

export const graphQLPostContents = includeTotalCount => `{
    ${includeTotalCount ? "totalCount" : ""}
    edges {
        node ${postContents}
        cursor
    }
    pageInfo {
        endCursor
        hasNextPage
    }
}`;

let notificationContents = `{
    id
    userId
    type
    postId
    post ${postContents}
    correctionId
    correction ${correctionContents}
    actingUser ${userContents}
    creationDate
    viewedAtDate
    openedAtDate
}`;

export const graphQLNotificationContents = includeTotalCount => `{
    ${includeTotalCount ? "totalCount" : ""}
    edges {
        node ${notificationContents}
        cursor
    }
    pageInfo {
        endCursor
        hasNextPage
    }
}`;

export function getUserQuery(uid) {
    return `{
        user(id: ${JSON.stringify(uid)}) ${userContents}
    }`;
}



// WEBPACK FOOTER //
// ./src/sagas/query.helper.js